export default "__VITE_ASSET__BwIzuhTf__"